/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { OfficeDto, OfficeMeasurement, OfficeStatus, OfficeType } from '@gh/builder-shared-data';

export type Office = OfficeDto;

export function createOffice(name: string, type?: OfficeType, status?: OfficeStatus): Office {
  return {
    id: '',
    name,
    type,
    status,
    measurementScale: OfficeMeasurement.Metric,
  } as Office;
}
